const textStyles = {
    subtitle: {
        desktopMain: {
            fontSize: "20px",
            fontWeight: 500,
            lineHeight: "125%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobileMain: {
            fontSize: "18px",
            fontWeight: 500,
            lineHeight: "130%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        card: {
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        section: {
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
    },
    title: {
        desktopPage: {
            fontSize: "42px",
            fontWeight: 900,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        desktopMain: {
            fontSize: "32px",
            fontWeight: 800,
            lineHeight: "125%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        desktopCard: {
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: "130%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        desktopSection: {
            fontSize: "24px",
            fontWeight: 700,
            lineHeight: "130%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobilePage: {
            fontSize: "32px",
            fontWeight: 800,
            lineHeight: "125%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobileMain: {
            fontSize: "24px",
            fontWeight: 800,
            lineHeight: "130%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobileCard: {
            fontSize: "20px",
            fontWeight: 700,
            lineHeight: "160%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobileSection: {
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "120%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
    },
    body: {
        largeXbold: {
            fontSize: "16px",
            fontWeight: 800,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        largeBold: {
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        largeDemibold: {
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        largeMedium: {
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        largeMediumLink: {
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "150%",
            letterSpacing: "-0.05em",
            textDecoration: "underline",
            textTransform: "none",
        },
        mediumXbold: {
            fontSize: "14px",
            fontWeight: 800,
            lineHeight: "145%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mediumBold: {
            fontSize: "14px",
            fontWeight: 700,
            lineHeight: "145%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mediumDemibold: {
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "145%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        medium: {
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "145%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mediumLink: {
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "145%",
            letterSpacing: "-0.05em",
            textDecoration: "underline",
            textTransform: "none",
        },
        smallXbold: {
            fontSize: "12px",
            fontWeight: 800,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        smallBold: {
            fontSize: "12px",
            fontWeight: 700,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        smallDemibold: {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        smallMedium: {
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        smallMediumLink: {
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "underline",
            textTransform: "none",
        },
        smallMediumItalic: {
            fontSize: "12px",
            fontWeight: 500,
            fontStyle: "italic",
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        xsmallMedium: {
            fontSize: "10px",
            fontWeight: 500,
            lineHeight: "160%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        xsmallMediumItalic: {
            fontSize: "10px",
            fontWeight: 500,
            fontStyle: "italic",
            lineHeight: "160%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
    },
    heroTitle: {
        desktopMediumBlack: {
            fontSize: "60px",
            fontWeight: 900,
            lineHeight: "110%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
        mobileMediumBlack: {
            fontSize: "42px",
            fontWeight: 900,
            lineHeight: "135%",
            letterSpacing: "-0.05em",
            textDecoration: "none",
            textTransform: "none",
        },
    },
};
export default textStyles;
//# sourceMappingURL=textStyles.js.map